/**
 * Generate a UUID with fallback for environments without crypto.randomUUID()
 * (e.g., older browsers, non-HTTPS contexts, or older Node versions).
 *
 * Lives in 1-Domains because Job and other domain entities self-assign IDs at
 * construction; the implementation only uses the standard `crypto` global,
 * which exists in browser, Node 16+, and Deno.
 */
export function generateUUID(): string {
	if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
		return crypto.randomUUID();
	}
	// Fallback using crypto.getRandomValues if available
	if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
		return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
			const r = (crypto.getRandomValues(new Uint8Array(1))[0] & 15) >> (c === "x" ? 0 : 2);
			const v = c === "x" ? r : (r & 0x3) | 0x8;
			return v.toString(16);
		});
	}
	// Last resort fallback using Math.random (less secure but works everywhere)
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}
